import { render, staticRenderFns } from "./CollectionRecordAdd.vue?vue&type=template&id=9efec728&scoped=true"
import script from "./CollectionRecordAdd.vue?vue&type=script&lang=js"
export * from "./CollectionRecordAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efec728",
  null
  
)

export default component.exports